import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';

// ฟังก์ชันวิเคราะห์ชื่อแอปพลิเคชันจาก roomName ใน URL Pathname
const getAppNameFromUrl = (): string => {
  if (typeof window === 'undefined') {
    return 'Cliniclive';
  }
  
  const segments = window.location.pathname.split('/').filter(segment => !!segment);
  const roomName = (segments[0] === 'auth' || segments[0] === 'meeting') ? (segments[1] || '') : (segments[0] || '');
  if (roomName) {
    const parts = roomName.split('-');
    if (parts.length >= 4) {
      const abbr = parts[0].toLowerCase();
      if (abbr === 'c') return 'Cliniclive';
      if (abbr === 'd') return 'Dentalpop';
      if (abbr === 'v') return 'Vettale';
    }
  }
  
  return 'Cliniclive';
};

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  // ตรวจสอบว่าเป็นการเรียกไปยัง api-telehealth หรือไม่
  const isTelehealthApi = req.url.startsWith(environment.apiUrlTelehealth);

  let requestToHandler = req;

  if (isTelehealthApi) {
    const token = sessionStorage.getItem('telehealth_temp_token');
    const appName = getAppNameFromUrl();
    const headers: { [key: string]: string } = {
      'Destination-Key': appName,
      'X-User-Agent': appName
    };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    requestToHandler = req.clone({
      setHeaders: headers
    });
  }

  return next(requestToHandler).pipe(
    catchError((error: HttpErrorResponse) => {
      // หากพบ Error 401 จาก API Telehealth
      if (error.status === 401 && isTelehealthApi) {
        // ล้างค่าข้อมูลประจำชั่วโมงเก่าออก
        sessionStorage.removeItem('telehealth_temp_token');
        sessionStorage.removeItem('telehealth_user_profile');

        // ตรวจจับชื่อห้องจาก Path URL (โครงสร้าง URL: /auth/:roomName หรือ /meeting/:roomName)
        const segments = window.location.pathname.split('/').filter(segment => !!segment);
        const roomName = (segments[0] === 'auth' || segments[0] === 'meeting') ? (segments[1] || '') : (segments[0] || '');

        if (roomName) {
          router.navigate([`/auth/${roomName}`]);
        } else {
          router.navigate(['/']);
        }
      }
      return throwError(() => error);
    })
  );
};
